import styled from '@emotion/styled'
import { Divider, Paragraph } from 'components/patterns'
import { wrap as withStyle, stylesIf } from 'utils/styles'
import { DEFAULT } from 'constants/ui/editor'
import ActionBar from 'components/ActionBar'

export default withStyle(
  () => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    ul {
      padding-left: 0;

      li {
        margin-top: 2px;
      }

      li:first-of-type {
        margin-top: 5px;
      }

      ${Paragraph} {
        margin-top: 0;
      }
    }

  `
)

export const StyledContent = styled.div`
  flex-grow: 1;
  overflow: auto;
`

export const StyledDivider = styled(Divider)`
  margin: 10px 0 !important;
`

export const Footer = styled(ActionBar)((props) => {
  const { buttons, buttonType } = props
  const buttonStyle = `justify-content: space-between`
  return `${stylesIf(
    buttonType === DEFAULT && buttons.length === 2,
    buttonStyle
  )}`
})

export const StyledBreadcrumb = styled.div((props) => {
  const {
    theme: { dimensions },
  } = props
  return `
    font-size: ${dimensions.small.fontSize};
    margin-bottom: 20px;
  `
})
